<template>
	<div>
		<template v-if="isActiveApp">
			<!-- محتوای واقعی اپ -->
			<PanguinPage />
		</template>
		<template v-else>
			<!-- اپلیکیشن غیرفعاله -->
			<div class="default-app">
				<h1>این اپلیکیشن به‌زودی اضافه خواهد شد</h1>
				<p>در حال توسعه هستیم، به زودی در دسترس قرار می‌گیرد 🚧</p>
			</div>
		</template>
	</div>
</template>

<script>
import PanguinPage from '@/components/apps/PanguinPage.vue'

export default {
	name: 'AppDetails',
	components: {
		PanguinPage
	},
	data() {
		return {
			activeApps: ['panguin']
		}
	},
	computed: {
		appId() {
			return this.$route.params.id
		},
		isActiveApp() {
			return this.activeApps.includes(this.appId)
		}
	}
}
</script>

<style scoped>
.default-app {
	min-height: 100vh;
	background-color: #1e1e2f;
	color: #fff;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-align: center;
	font-family: 'iransans', sans-serif;
	padding: 2rem;
}
</style>